/**
 * Smooth open/close for <details> accordions (Nonomic FAQ + product PDP)
 */
(function () {
  const DURATION_MS = 350;
  const EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';
  const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const MODULES = [
    {
      root: '.nonomic-faq',
      details: '.nonomic-faq__item',
      content: '.nonomic-faq__answer',
      closingClass: 'nonomic-faq__item--closing',
      jsClass: 'nonomic-faq--js',
      dataKey: 'faqInit',
    },
    {
      root: '.product__accordion',
      details: 'details',
      content: '.accordion__content',
      closingClass: 'product-accordion--closing',
      jsClass: 'product__accordion--js',
      dataKey: 'productAccordionInit',
    },
  ];

  function supportsDetailsContent() {
    return CSS.supports('selector(::details-content)');
  }

  function resetContentStyles(content) {
    content.style.height = '';
    content.style.overflow = '';
    content.style.transition = '';
  }

  function openDetails(details, content, closingClass) {
    details.setAttribute('open', '');

    if (REDUCED_MOTION) return;

    const targetHeight = content.scrollHeight;
    content.style.overflow = 'hidden';
    content.style.height = '0px';

    requestAnimationFrame(() => {
      content.style.transition = `height ${DURATION_MS}ms ${EASING}`;
      content.style.height = `${targetHeight}px`;
    });

    const onEnd = (event) => {
      if (event.propertyName !== 'height') return;
      resetContentStyles(content);
      content.removeEventListener('transitionend', onEnd);
    };

    content.addEventListener('transitionend', onEnd);
  }

  function closeDetails(details, content, closingClass) {
    if (REDUCED_MOTION) {
      details.removeAttribute('open');
      return;
    }

    const startHeight = content.scrollHeight;
    content.style.overflow = 'hidden';
    content.style.height = `${startHeight}px`;
    details.classList.add(closingClass);

    requestAnimationFrame(() => {
      content.style.transition = `height ${DURATION_MS}ms ${EASING}`;
      content.style.height = '0px';
    });

    const onEnd = (event) => {
      if (event.propertyName !== 'height') return;
      details.removeAttribute('open');
      details.classList.remove(closingClass);
      resetContentStyles(content);
      content.removeEventListener('transitionend', onEnd);
    };

    content.addEventListener('transitionend', onEnd);
  }

  function bindDetails(details, config) {
    const summary = details.querySelector('summary');
    const content = details.querySelector(config.content);
    if (!summary || !content) return;

    summary.addEventListener('click', (event) => {
      event.preventDefault();
      if (details.classList.contains(config.closingClass)) return;

      if (details.open) {
        closeDetails(details, content, config.closingClass);
      } else {
        openDetails(details, content, config.closingClass);
      }
    });
  }

  function initModule(config, scope) {
    const roots = scope ? scope.querySelectorAll(config.root) : document.querySelectorAll(config.root);

    roots.forEach((root) => {
      if (root.dataset[config.dataKey] === 'true') return;
      if (supportsDetailsContent() && !REDUCED_MOTION) return;

      root.dataset[config.dataKey] = 'true';
      root.classList.add(config.jsClass);

      root.querySelectorAll(config.details).forEach((details) => {
        bindDetails(details, config);
      });
    });
  }

  function init(scope) {
    MODULES.forEach((config) => initModule(config, scope || null));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
